import { Day } from "@/API";

export const FAMOUS_PLACE = {
  fr: [
    {
      name: "Paris",
      position: {
        location: {
          latitude: 48.857547499999995,
          longitude: 2.3513764999999998,
        },
        boundingBox: {
          topLeft: {
            latitude: 48.902147629279796,
            longitude: 2.4698511104444334,
          },
          bottomRight: {
            latitude: 48.81556220872687,
            longitude: 2.224217068042387,
          },
        },
      },
    },
    {
      name: "Lyon",
      position: {
        location: {
          latitude: 45.764043,
          longitude: 4.835659,
        },
        boundingBox: {
          topLeft: {
            latitude: 45.808420230248124,
            longitude: 4.8983956820203876,
          },
          bottomRight: {
            latitude: 45.707481239572886,
            longitude: 4.771852009831904,
          },
        },
      },
    },
    {
      name: "Marseille",
      position: {
        location: {
          latitude: 43.302574199999995,
          longitude: 5.369074299999999,
        },
        boundingBox: {
          topLeft: {
            latitude: 43.391056526002636,
            longitude: 5.532543303418947,
          },
          bottomRight: {
            latitude: 43.16963132649933,
            longitude: 5.228751052552003,
          },
        },
      },
    },
    {
      name: "Nice",
      position: {
        location: {
          latitude: 43.710172799999995,
          longitude: 7.261953200000001,
        },
        boundingBox: {
          topLeft: {
            latitude: 43.760909551425065,
            longitude: 7.323476132114016,
          },
          bottomRight: {
            latitude: 43.64540566021803,
            longitude: 7.182147752528378,
          },
        },
      },
    },
    {
      name: "Bordeaux",
      position: {
        location: {
          latitude: 44.841610599999996,
          longitude: -0.5810938000000001,
        },
        boundingBox: {
          topLeft: {
            latitude: 44.916694160987724,
            longitude: -0.5333254042171431,
          },
          bottomRight: {
            latitude: 44.81074150294608,
            longitude: -0.6386988942164198,
          },
        },
      },
    },
    {
      name: "Toulouse",
      position: {
        location: {
          latitude: 43.6048462,
          longitude: 1.442848,
        },
        boundingBox: {
          topLeft: {
            latitude: 43.668713702087416,
            longitude: 1.5153557845438768,
          },
          bottomRight: {
            latitude: 43.53269301030462,
            longitude: 1.350329287609379,
          },
        },
      },
    },
  ],
  en: [
    {
      name: "London",
      position: {
        location: {
          latitude: 51.5072178,
          longitude: -0.12758619999999998,
        },
        boundingBox: {
          topLeft: {
            latitude: 51.8822255,
            longitude: 0.14827103356112006,
          },
          bottomRight: {
            latitude: 51.384940124290964,
            longitude: -0.4149317000000015,
          },
        },
      },
    },
    {
      name: "Manchester",
      position: {
        location: {
          latitude: 53.480759299999995,
          longitude: -2.2426304999999997,
        },
        boundingBox: {
          topLeft: {
            latitude: 53.54458793949853,
            longitude: -2.146828844526851,
          },
          bottomRight: {
            latitude: 53.36565100000001,
            longitude: -2.300096904893769,
          },
        },
      },
    },
    {
      name: "Birmingham",
      position: {
        location: {
          latitude: 52.4822694,
          longitude: -1.8900077999999998,
        },
        boundingBox: {
          topLeft: {
            latitude: 52.60869933491674,
            longitude: -1.7098293726535285,
          },
          bottomRight: {
            latitude: 52.38599896742283,
            longitude: -2.017433632448159,
          },
        },
      },
    },
    {
      name: "Leeds",
      position: {
        location: {
          latitude: 53.8007554,
          longitude: -1.5490773999999998,
        },
        boundingBox: {
          topLeft: {
            latitude: 53.88120207888145,
            longitude: -1.397373104235037,
          },
          bottomRight: {
            latitude: 53.7308029402404,
            longitude: -1.674091522121716,
          },
        },
      },
    },
    {
      name: "Liverpool",
      position: {
        location: {
          latitude: 53.4083714,
          longitude: -2.9915726,
        },
        boundingBox: {
          topLeft: {
            latitude: 53.48621000000001,
            longitude: -2.818000144896959,
          },
          bottomRight: {
            latitude: 53.31154257793854,
            longitude: -3.019179335864527,
          },
        },
      },
    },
    {
      name: "Cardiff",
      position: {
        location: {
          latitude: 51.483706999999995,
          longitude: -3.1680962,
        },
        boundingBox: {
          topLeft: {
            latitude: 51.560906285899215,
            longitude: -3.11643735486853,
          },
          bottomRight: {
            latitude: 51.443575161147415,
            longitude: -3.293662576756845,
          },
        },
      },
    },
  ],
};

export const COLUMNS_GRID_BUILDER = [
  "krunsh_score",
  "rank",
  "rating",
  "reviews_count",
  "delivery_time",
  "promotion_active",
  "promotion_type",
  "menu_items",
  "hero_image",
  "shifts",
  "categories",
];

export const DAYS = [
  Day.SUNDAY,
  Day.MONDAY,
  Day.TUESDAY,
  Day.WEDNESDAY,
  Day.THURSDAY,
  Day.FRIDAY,
  Day.SATURDAY,
];
